import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import {
  DownOutlined,
  WalletOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import MobileAccountTabs from "./components/MobileAccountTabs.jsx";
import {
  GetDashboardApi,
  GetUserProgressApi,
  YourWallet,
} from "../../../api/request/dashboard.js";
import BalanceCard from "./components/BalanceCardSM.jsx";
import { useSelector } from "react-redux";
import PnLCardGridSM from "./components/PnLCardGridSM.jsx";
import OpenTrades from "./components/OpenTrades.jsx";
import RecentTableMobile from "./components/RecentTableMobile.jsx";
import UserProgressBar from "./components/UserProgressBar.jsx";
import CreateLiveAccount from "./components/CreateLiveAccount.jsx";

const MobileDashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [accountLogins, setAccountLogins] = useState([]);
  const [activeAccountLogins, setActiveAccountLogins] = useState("");
  const [data, setData] = useState([]);
  const [userProgress, setUserProgress] = useState(null);
  const [balanceCards, setBalanceCards] = useState([
    {
      id: 1,
      type: "Wallet",
      amount: 0.0,
      color: "bg-blue-500",
      gradient: "from-[#EFF6FF] to-[#ffff]",
      icon: <WalletOutlined size={20} color="#fff" className="text-white" />,
    },
    {
      id: 2,
      type: "Deposits",
      amount: 0.0,
      color: "bg-green-500",
      gradient: "from-[#ECFDF5] to-[#ffff]",
      icon: (
        <PlusCircleOutlined size={20} color="#fff" className="text-white" />
      ),
    },
    {
      id: 3,
      type: "Withdraws",
      amount: 0.0,
      color: "bg-teal-500",
      gradient: "from-[#EDFFFF] to-[#ffff]",
      icon: <WalletOutlined size={20} color="#fff" className="text-white" />,
    },
  ]);
  const { userDetails } = useSelector((state) => state.user);

  const filterAccounts = (accountList = []) => {
    const accountLogins = accountList
      ?.filter((account) => account?.isLive)
      ?.map((account) => account?.terminalID);

    setAccountLogins(accountLogins);
    setActiveAccountLogins(accountLogins?.[0]);
  };

  const getDashboard = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetDashboardApi();
      if (data?.success) {
        setData(data?.data);
        setBalanceCards((prev) =>
          prev.map((item) => {
            if (item.id === 1)
              return { ...item, amount: data?.data?.walletAmount };
            if (item.id === 2)
              return { ...item, amount: data?.data?.depositAmount };
            if (item.id === 3)
              return { ...item, amount: data?.data?.withdrawAmount };
            return item;
          })
        );
        filterAccounts(data?.data?.accountList);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const getWallet = async () => {
    try {
      const { data } = await YourWallet(userDetails?.id);
      if (data?.success) {
        setBalanceCards((prev) =>
          prev.map((item) =>
            item.id === 1 ? { ...item, amount: data?.data?.walletAmount } : item
          )
        );
      }
    } catch (error) {}
  };

  const getUserProgress = async () => {
    try {
      const { data } = await GetUserProgressApi();
      if (data?.success) {
        setUserProgress(data?.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getDashboard();
    getWallet();
    getUserProgress();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center flex-col mt-[20%]">
        <Spin size="large" />
        <p className="primary text-center mt-2">Loading...</p>
      </div>
    );
  }

  if (accountLogins.length === 0) {
    return (
      <div className="mobile-dashboard min-h-screen">
        <div className="mb-4">
          <UserProgressBar progress={userProgress} />
        </div>
        <CreateLiveAccount progress={userProgress} />
      </div>
    );
  }
  return (
    <div className="mobile-dashboard min-h-screen">
      <div className="mb-4">
        <div className="relative">
          <div className="mb-4">
            <UserProgressBar progress={userProgress} />
          </div>



          {accountLogins.length > 0 && (
            <Select
              value={activeAccountLogins}
              onChange={setActiveAccountLogins}
              className="w-full !bg-white rounded-xl"
              size="large"
              suffixIcon={
                <div className="flex items-center justify-center h-full w-full">
                  <DownOutlined className="text-gray-400 bg-[#F5F9FD] p-2.5 rounded-lg" />
                </div>
              }
              popupClassName="custom-select-dropdown"
              dropdownAlign={{ offset: [0, 0] }}
              dropdownStyle={{
                borderRadius: "16px",
                padding: "8px",
                boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                border: "none",
                marginTop: "-10px",
              }}
              optionLabelProp="label"
            >
              {accountLogins.map((id) => (
                <Select.Option
                  key={id}
                  value={id}
                  label={
                    <span className="primary font-bold text-base">{id}</span>
                  }
                >
                  <div className="flex items-center justify-between py-1 px-2 rounded-lg">
                    <span
                      className={`font-medium text-base ${activeAccountLogins === id ? "primary" : "text-gray-700"
                        }`}
                    >
                      {id}
                    </span>
                    {activeAccountLogins === id && (
                      <IoCheckmarkDoneSharp
                        className="primary text-sm ml-4"
                        size={22}
                      />
                    )}
                  </div>
                </Select.Option>
              ))}
            </Select>
          )}
        </div>
      </div>

      <div className="space-y-6">
        {/* Balance Cards */}
        <div>
          <div className="grid grid-cols-3 gap-3">
            {balanceCards.map((card, index) => (
              <BalanceCard
                key={card.id || index}
                type={card.type}
                amount={card.amount}
                color={card.color}
                gradient={card.gradient}
                icon={card.icon}
              />
            ))}
          </div>
        </div>

        <PnLCardGridSM loginId={activeAccountLogins} />

        {/* Open Trades */}
        <div className="bg-white rounded-2xl">
          <div className='flex items-center justify-between p-4 border-b border-gray-200'>
            <h2 className="text-lg font-semibold text-gray-600">Open Trades</h2>
            {/* <a href={`/trades/${activeAccountLogins}`} className='text-sm text-blue-500'>View All</a> */}
          </div>

          <div className="p-4">
            <OpenTrades loginId={activeAccountLogins} />
          </div>
        </div>

        {/* Trading Accounts */}
        <MobileAccountTabs data={data?.accountList} loading={isLoading} />

        {/* Recent Transactions */}
        <RecentTableMobile data={data} />

        {/* Action Buttons */}

      </div>
    </div>
  );
};

export default MobileDashboard;
